import { render, staticRenderFns } from "./ExadataObservations.vue?vue&type=template&id=2915a631"
import script from "./ExadataObservations.vue?vue&type=script&lang=js"
export * from "./ExadataObservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports